export const addFormatAndQualityAutoIntoUrl = (cdnUrl: string) => {
  return cdnUrl.replace('/upload/', '/upload/f_auto,q_auto/');
};

export const getPictureUrl = (folder: string, pictureName: string) => {
  return `https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_auto/fudzi/retail-media/${folder}/${pictureName}/${pictureName}`;
};
